import './JTBDRealLifeExamples.scss';

const jtbdSection = {
  title: 'Exemplos do Mundo Real',
  subtitle: [
    'De cada vez que um cliente compra um produto ou serviço, ele não está apenas a adquirir algo, mas sim a contratar esse produto ou serviço para fazer um trabalho específico na sua vida. Este trabalho chama-se Job To Be Done (ou Trabalho a Ser Feito).',
    'Pense nos exemplos seguintes:',
  ],
};

const examplesData = [
  {
    title: 'Bolo de uma Pastelaria',
    imageUrl: '/images/jtbdpage/cake.svg',
    description: 'O cliente quer mais do que adquirir um doce. Pode querer:',
    list: [
      'Celebrar uma conquista',
      'Criar memórias felizes com a família',
      'Proporcionar um momento de prazer.',
    ],
  },
  {
    title: 'Automóvel',
    imageUrl: '/images/jtbdpage/car.webp',
    description: 'O cliente quer mais do que deslocar-se. Pode querer:',
    list: ['Sentir-se seguro', 'Poupar tempo', 'Sentir-se bem sucedido'],
  },
  {
    title: 'Lavandaria',
    imageUrl: '/images/jtbdpage/laundry.webp',
    description: 'O cliente quer mais do que roupa lavada. Pode querer:',
    list: [
      'Poupar tempo e ter tranquilidade',
      'Garantir que as roupas ficam impecáveis',
    ],
  },
];

const JTBDRealLifeExamples = () => {
  return (
    <section className="JTBD-RL section">
      <div className="wrapper wrapper--medium">
        <h2 className="wrapper__title centered">
          {jtbdSection.title}
        </h2>

        <div className="wrapper__subtitle wrapper--small centered">
          {jtbdSection.subtitle.map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
        </div>

        <div className="row col-4">
          {examplesData.map((item, index) => (
            <div
              key={index}
              className="col card card--rounded card--no-shadow"
            >
              <img
                alt=""
                className="card__illustration--small"
                src={item.imageUrl}
              />
              <h3 className="card__title h4">{item.title}</h3>
              <div className="card__description">
                <p>{item.description}</p>
                <ul className="card__list">
                  {item.list.map((point, idx) => (
                    <li key={idx}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JTBDRealLifeExamples;
